var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100vh", overflow: "hidden" } },
    [_c("DashboardPlusV3")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }